import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Medicine} from "../../model/medicine.type";
import {MedicineBookEntriesResult, MedicineService} from "../../services/medicine.service";
import {ApolloQueryObservable} from "apollo-angular";
import {MedicineBookEntry} from "../../model/medicine-book-entry";
import {StockService} from "../../services/stock.service";
import {Stock} from "../../../shared/view-model/stock";
import {map} from "rxjs/operators";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {FileService} from "../../../core/visbos-core/http/file.service";
import {StockItem} from '../../../shared/view-model/store-management/stock-item.type';

@Component({
  selector: 'vb-medicine-book-view',
  templateUrl: './medicine-book-view.component.html',
  styleUrls: ['./medicine-book-view.component.css']
})
export class MedicineBookViewComponent extends AbstractVisbosComponent implements OnInit {

  private medicineStock$: ApolloQueryObservable<Stock>;
  private medicineCuid: string[] = null;

  medicine: Medicine | StockItem;
  medicineStock: Stock;

  private medicineBookEntries$: ApolloQueryObservable<MedicineBookEntriesResult>;
  medicineBookEntries: MedicineBookEntry[];

  isLoading: boolean = true;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private route: ActivatedRoute,
              private medicineService: MedicineService,
              private stockService: StockService,
              private fileService: FileService) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'PDF generieren',
        icon: 'fa-file-pdf',
        action: () => this.generateMedBook.apply(this),
        helpText: "Verbrauchsnachweis als PDF exportieren",
      }
    ];

  }

  ngOnInit() {

    let medicineStockCuid$ = this.route.params.pipe(map(p => p.medicineStockCuid));

    this.medicineStock$ = this.stockService.getMedicineStock(medicineStockCuid$);
    this.addComponentData(this.medicineStock$);
    this.dataSubscriptions.push(this.medicineStock$.subscribe((res: any) => {
        this.medicineStock = res.data.fetchStockDetails;
        this.medicine = this.medicineStock.stock_item.medicine ? this.medicineStock.stock_item.medicine : null;
      })
    );

    this.dataSubscriptions.push(medicineStockCuid$.subscribe(cuid => {
      this.medicineCuid = cuid;
      this.medicineStock$.setVariables({
        cuid: cuid
      });
    }));


    this.medicineBookEntries$ = this.medicineService.fetchMedicineBookEntries(medicineStockCuid$);
    this.addComponentData(this.medicineBookEntries$);
    this.dataSubscriptions.push(this.medicineBookEntries$.subscribe(res => {
      this.medicineBookEntries = res.data.medicineBookEntries;
      this.isLoading = res.loading;
    }))

  }

  generateMedBook() {

    this.dataSubscriptions.push(
      this.medicineService.generateMedicineBookPdf([this.medicineStock.cuid]).subscribe(
        res => {
          //this.orderPdfLink = res.data.generateOrderPDF;
          let data = this.fileService.base64toBlob(res.data.medicineBookPdf, 'application/pdf', 512);
          this.fileService.saveAs(data, 'verbrauchsbuch.pdf');
        }, err => {
          this.sessionActions.pushMessage("Fehler beim Generieren der PDF-Datei", MessageType.ERROR, "PDF-Erzeugung");
        })
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/medicine-book-view/medicine-book-view.component.ts